"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MODE;
(function (MODE) {
    MODE["VIRTUAL"] = "virtual";
    MODE["FAKE"] = "fake";
    MODE["NATIVE"] = "native";
})(MODE = exports.MODE || (exports.MODE = {}));
var EVENTS;
(function (EVENTS) {
    EVENTS["WHEEL"] = "wheel";
    EVENTS["TOUCH"] = "touch";
    EVENTS["SPACEBAR"] = "spacebar";
    EVENTS["ARROWS"] = "arrows";
    EVENTS["KEYS"] = "keys";
    EVENTS["SCROLL"] = "scroll";
})(EVENTS = exports.EVENTS || (exports.EVENTS = {}));
var KEYCODE;
(function (KEYCODE) {
    KEYCODE[KEYCODE["LEFT"] = 37] = "LEFT";
    KEYCODE[KEYCODE["UP"] = 38] = "UP";
    KEYCODE[KEYCODE["RIGHT"] = 39] = "RIGHT";
    KEYCODE[KEYCODE["DOWN"] = 40] = "DOWN";
    KEYCODE[KEYCODE["SPACE"] = 32] = "SPACE";
})(KEYCODE = exports.KEYCODE || (exports.KEYCODE = {}));
var DELTA_SCALE;
(function (DELTA_SCALE) {
    DELTA_SCALE[DELTA_SCALE["STANDARD"] = 1] = "STANDARD";
    DELTA_SCALE[DELTA_SCALE["OTHERS"] = -3] = "OTHERS";
})(DELTA_SCALE = exports.DELTA_SCALE || (exports.DELTA_SCALE = {}));
;
exports.DELTA_MODE = [1.0, 28.0, 500.0];
